import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import { Button, Table } from "react-bootstrap";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import FilterPannel from "../../filter/FilterPannel";
import moment from 'moment';

class LeadBySourceBySalesPerson extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model)
    const sourceOptions = model.source.options.filter((option)=>option.status === Constants.Active || option.status === Constants.AlwaysActive) || [];
    const userOptions = model.user.options.filter((option)=>option.status === Constants.Active || option.status === Constants.AlwaysActive) || [];
    this.fields = model.lead.fields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      sourceOptions,
      userOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",        
        value: `~${this.loggedInUserId}~`,
      },{
        "field": "enquiry_date",
        "condition": "in",
        "value": `${moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')}~${moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')}`
      }],
      tableData:[],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount(l) {
    this.fetchApi(this.state.filters,this.onSuccess, this.onFail);
  }


 fetchApi = (filters,onSuccess, onFail) => {
    const body = {
      filters : filters,
      model: "lead_model",
      x:"source",
      y:"responsible_person",
      z:"COUNT(id)"
    }
    this.setState({inApiCall: true})
    DailySalesReportAPI.getFixedReport(body, onSuccess, onFail);
  };



  parseData=(response )=>{
    let selectedUserId ,filteredUserOptions;
    this.state.filters.map(filter => filter.field === 'responsible_person' ?  selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = this.state.userOptions.filter(user => { 
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
    //    Prepare table data
    const tableData = this.state.sourceOptions.map((source) => {
      const row = { source: source.label };
      filteredUserOptions.forEach((person) => {
        // Calculate the total sum for each responsible person per source
        const totalSum = response
          .filter(
            (item) =>
              {
                return item.source === source.value &&
                item.responsible_person.includes(`~${person.value}~`)  
          })
          .reduce((sum, item) => sum + (item.sum || 0), 0);
  
        row[person.label] = totalSum;
      });
      return row;
    });
  
    // Prepare chart series
    const series = filteredUserOptions.map((person) => ({
      name: person.label,
      data: this.state.sourceOptions.map((source) => {
        // Calculate the total sum for each responsible person per source
        const totalSum = response
          .filter(
            (item) =>
              {
                return item.source=== source.value &&
             item.responsible_person.includes(`~${person.value}~`)
          })
          .reduce((sum, item) => sum + (item.sum || 0), 0);
  
        return totalSum;
      }),
    }));
return { tableData, series };
}

  onSuccess =(data)=>{
    const {tableData , series} = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData,series ,exportData, inApiCall: false  });  
  }

  onFail = (err) =>{
    console.log("Failed to fetch data" , err);
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },    
     this.fetchApi(this.state.filters,this.onSuccess, this.onFail));
  };

   
    

render(){
const {exportData , filters ,isFilterOpen , inApiCall ,sourceOptions , tableData , series  } = this.state;
  let selectedUserId ,filteredUserOptions;
    this.state.filters.map(filter => filter.field === 'responsible_person' ?  selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = this.state.userOptions.filter(user => { 
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
  const table = (<Table bordered hover striped responsive>
    <thead>
      <tr>
        <th></th>
        {filteredUserOptions.map((person, index) => (
          <th key={index}>{person.label}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {tableData.map((row, index) => (
        <tr key={index}>
          <td>{row.source}</td>
          {filteredUserOptions.map((person, idx) => (
            <td key={idx}>{row[person.label]}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </Table>);

  return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h1>Lead By Source By Sales Person</h1>
                </div>
                <div className="col-md-6">
                  <CSVLink data={exportData} filename={`lead_By_source_By_salesPerson_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                <StackedChartComponent progressOptions={sourceOptions} progressSums={series} type={"multiBar"} />
                <div className="col-md-12">{table}</div>
                </div>
                {this.state.isFilterOpen && (
                  <FilterPannel
                    filters={filters}
                    fields={this.fields}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={isFilterOpen}
                    restrict={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>)


}
}


export default LeadBySourceBySalesPerson;

